import updateUserConfigurationPont from '../actions/actionCreators/updateUserConfigurationPont';
import ignoreConversationsService from '../services/ignoreConversationsService';
import loc, { format } from 'owa-localize';
import { userMailInteractionAction } from 'owa-mail-actions';
import deleteConversationStoreUpdate from 'owa-mail-actions/lib/triage/deleteConversationStoreUpdate';
import { IgnoreConversationsConfirmDialog } from 'owa-mail-ignore-view';
import { listViewStore, MailRowDataPropertyGetter } from 'owa-mail-list-store';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import { processApplyConversationActionResponseMessage } from 'owa-mail-triage-action-response-processor';
import PontType from 'owa-service/lib/contract/PontType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { orchestrator } from 'satcheljs';
import {
    ignore_ignoreDialogTitle,
    ignore_ignoreDialogTitleNItems,
    ignore_stopIgnoringDialogTitle,
    ignore_stopIgnoringDialogTitleNItems,
    ignore_ignoreDialogSubtext,
    ignore_stopIgnoringDialogSubtext,
} from './toggleIgnoreConversationsOrchestrator.locstring.json';
import toggleIgnoreConversations, {
    internalToggleIgnoreConversations,
} from '../actions/toggleIgnoreConversations';

export default orchestrator(toggleIgnoreConversations, actionMessage => {
    const shouldIgnore = actionMessage.shouldIgnore;
    const rowKeysToIgnore = actionMessage.rowKeysToIgnore;

    const pontType: PontType = shouldIgnore
        ? PontType.IgnoreConversation
        : PontType.CancelIgnoreConversation;

    // show dialog if pont is set
    if ((pontType & getUserConfiguration().UserOptions.NewEnabledPonts) == pontType) {
        let dialogTitle: string;

        if (shouldIgnore) {
            dialogTitle =
                rowKeysToIgnore.length == 1
                    ? loc(ignore_ignoreDialogTitle)
                    : format(loc(ignore_ignoreDialogTitleNItems), rowKeysToIgnore.length);
        } else {
            dialogTitle =
                rowKeysToIgnore.length == 1
                    ? loc(ignore_stopIgnoringDialogTitle)
                    : format(loc(ignore_stopIgnoringDialogTitleNItems), rowKeysToIgnore.length);
        }
        const dialogText = shouldIgnore
            ? loc(ignore_ignoreDialogSubtext)
            : loc(ignore_stopIgnoringDialogSubtext);

        const dialog = new IgnoreConversationsConfirmDialog(
            dialogTitle,
            dialogText,
            checked => {
                if (checked) {
                    updateUserConfigurationPont(pontType);
                }
                internalToggleIgnoreConversations(
                    actionMessage.rowKeysToIgnore,
                    actionMessage.tableViewId,
                    shouldIgnore,
                    actionMessage.actionSource
                );
            },
            () => {} /* onDismiss */
        );
        dialog.show();
    } else {
        // pont already set, toggle ignore without dialog
        internalToggleIgnoreConversations(
            actionMessage.rowKeysToIgnore,
            actionMessage.tableViewId,
            shouldIgnore,
            actionMessage.actionSource
        );
    }
});

orchestrator(internalToggleIgnoreConversations, actionMessage => {
    const { shouldIgnore, tableViewId, rowKeysToIgnore } = actionMessage;
    const conversationIds: string[] = [];
    const tableView = listViewStore.tableViews.get(tableViewId);

    for (const rowKey of rowKeysToIgnore) {
        conversationIds.push(MailRowDataPropertyGetter.getConversationId(rowKey, tableView));
    }

    if (shouldIgnore) {
        const instrumentationContexts = getInstrumentationContextsFromTableView(
            rowKeysToIgnore,
            tableView
        );
        userMailInteractionAction('Ignore', instrumentationContexts);
    }

    // clean up items client side
    deleteConversationStoreUpdate(conversationIds, tableView, 'Ignore');

    const ignoreConversationPromise = ignoreConversationsService(
        conversationIds,
        tableView.tableQuery.folderId,
        shouldIgnore
    );

    return processApplyConversationActionResponseMessage(
        ignoreConversationPromise,
        rowKeysToIgnore,
        tableView.tableQuery.folderId,
        tableViewId,
        /*
         * Ignore operation is performed upon delay server-side and not immediately, hence we get
         * row modified notifications while each item in the conversation is getting moved to deleted items folder
         * Hence we do not want to remove this entry from tombstone when action completes, rather we will wait
         * for the rowDelete notification and remove it then which guarantees that the row has been completely
         * moved to deleted items folder
         */
        false /* shouldRemoveRowsFromTombstone */
    );
});
